var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.69231C19 10.4893 18.6071 11.6029 17.8754 12.9228C17.1614 14.2108 16.197 15.5697 15.2136 16.8215C14.2332 18.0695 13.2504 19.1903 12.5113 20.0003C12.3234 20.2062 12.1516 20.3916 12 20.5536C11.8484 20.3916 11.6766 20.2062 11.4887 20.0003C10.7496 19.1903 9.76675 18.0695 8.78637 16.8215C7.80299 15.5697 6.83856 14.2108 6.12461 12.9228C5.39294 11.6029 5 10.4893 5 9.69231C5 6.03285 8.09668 3 12 3C15.9033 3 19 6.03285 19 9.69231Z",
    stroke: "#F32B2B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 9.69234C14.2 10.8028 13.2524 11.7693 12 11.7693C10.7477 11.7693 9.80005 10.8028 9.80005 9.69234C9.80005 8.58189 10.7477 7.61542 12 7.61542C13.2524 7.61542 14.2 8.58189 14.2 9.69234Z",
    stroke: "#F32B2B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.71947276274dcf0dce368e1a98931d22.svg";
export { ForwardRef as ReactComponent };